var mountElement = document.querySelector('#size-calculator-app');
var app = new Vue({
  el: '#size-calculator-app',
  data() {
    return {
      availableSizes: mountElement.getAttribute('size-options').split('|'),
      optionName: mountElement.getAttribute('option-name'),
      showingResults: false,

      unit: 'inches',
      form: {},
      title: 'Size calculator',
      intro: 'Use this size calculator to discover the perfect pump for you. Learn how to correctly measure yourself',
      recommendation: {},
      selectedSize: null,
      showingSizeGuide: false
    }
  },
  computed: {
    isFormValid() {
      return (this.form.length && this.form.length > 0) && (this.form.girth && this.form.girth > 0);
    },
    matchedSizes() {
      if (!this.form.length && !this.form.girth) {
        return this.availableSizes;
      }

      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      return this.availableSizes.filter((size) => {
        const sizeValue = this.mapSizeToValue(size);

      if (lengthValue <= 3) {

        if (girthValue <= 6) {
                  return [3].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 3.5) {
      
        if (girthValue <= 6) {
                  return [3,5].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 5) {
      
        if (girthValue <= 6) {
                  return [5].includes(sizeValue);
        }
        
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 5.5) {
      
        if (girthValue <= 6) {
                  return [5,6].includes(sizeValue);
        }
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
      
      }
      
      
      if (lengthValue < 6) {
      
        if (girthValue <= 6.5) {
                  return [6].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 6.5) {
      
        if (girthValue <= 6.5) {
                  return [6,7].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 7) {
      
        if (girthValue <= 6.5) {
                  return [7].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 7.5) {
      
        if (girthValue <= 6.5) {
                  return [7,8].includes(sizeValue);
        }
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return ['7wb'].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 8) {
      
        if (girthValue <= 7) {
                  return [8].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return [9].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 8.5) {
      
        if (girthValue <= 7) {
                  return [8,9].includes(sizeValue);
        }
        if (girthValue <= 7.5) {
                  return [9].includes(sizeValue);
        }
      
      }
      
      if (lengthValue < 9.5) {
      
        if (girthValue <= 7.5) {
                  return [9,11].includes(sizeValue); // Size 11 is included in the return type for the task #129
        }
      
      }

        return false;
      }).sort();
    }
  },
  methods: {
    getResults() {
      this.setRecommendation();
      this.showingResults = true;
    },
    setRecommendation() {
      const lengthValue = this.unit === 'centimeters' ? parseFloat(this.form.length / 2.5) : parseFloat(this.form.length);
      const girthValue = this.unit === 'centimeters' ? parseFloat(this.form.girth / 2.5) : parseFloat(this.form.girth);

      const recommendedSize = () => {
        switch (true) {
          case (girthValue <= 5.5 && lengthValue <= 3):
            return [3];
          case (girthValue <= 6 && lengthValue <= 5):
            return [5];
          case (girthValue <= 6.5 && lengthValue <= 6):
            return [6];
          case (girthValue <= 6 && lengthValue <= 7):
            return [7];
          case (girthValue <= 7.5 && lengthValue <= 7):
            return ['7wb'];
          case (girthValue <= 7 && lengthValue <= 8):
            return [8];
          case (girthValue <= 7.5 && lengthValue <= 9.5):
            return [9];
         case (girthValue <= 8.5 && lengthValue <= 10.5):
            return [11];
          default:
            return [];
        }
      }

      this.recommendation = this.availableSizes.find((size) => recommendedSize().includes(this.mapSizeToValue(size)));
    },
    setUnit(unit) {
      this.unit = unit;
    },
    setSize(size) {
      this.selectedSize = size;
      // code to alter the size for the task #129
      if(size == "7 wb"){
        size = "7 Wide Boy";
      }
      const input = document.querySelector(`[name="${this.optionName}"][value="${size}"]`);
      input.click();
      //this.restart();
    },
    mapSizeToValue(size) {
      const intVal = parseFloat(size.replace(/\D/g, ""));    
      const plusRegex = new RegExp("wb", "i");

      if (plusRegex.test(size)) {
          return `${intVal}wb`;
      }
  
      return intVal;
    },
    restart() {
      this.form = {};
      this.showingResults = false;
    },
    complete() {
      //document.querySelector('.drawer__close').click();
      var modal = document.getElementsByClassName('custom-modal');
      modal[0].removeAttribute('open');
      document.body.style.overflow = 'auto';
      this.selectedSize = null;
      this.restart();
    },
    toggleSizeGuide() {
      this.showingSizeGuide = !this.showingSizeGuide;
    },
    hideSizeGuide() {
      this.showingSizeGuide = false;
    }
  },
  mounted() {
    document.body.addEventListener('modalClosed', this.hideSizeGuide);
  },
  unmounted() {
    document.body.removeEventListener('modalClosed', this.hideSizeGuide);
  },
  delimiters: ['${', '}'],
})